exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".card-request-success{position:relative}.card-request-success .icon-cross{position:absolute;top:10px;right:10px;font-size:15px;color:#aeaeae;cursor:pointer}.card-request-success .icon-confirmation{display:block;font-size:40px;width:40px;margin:auto;padding-top:22px;padding-bottom:15px;color:#86c82d}.card-request-success p{max-height:70px;overflow-x:hidden;text-align:center;letter-spacing:.5px;padding:0 15px;line-height:1.3;font-family:Stag Sans}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/food-benefit.module/components/userCardList/userCardRow/homeCard/cardRequestSuccess/cardRequestSuccess.scss
// module id = 1613
// module chunks = 0